
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { CompaniesService } from './services/';
import { CompanyService } from './services/';
import { CompaniesReducer } from './store/reducers'
import { PbxService } from './services/pbx.service';
import { EffectsModule } from '@ngrx/effects';
import { CompaniesEffects } from './store/effects/companies.effect';

@NgModule({
  imports: [
    StoreModule.forFeature("companies", CompaniesReducer),
    EffectsModule.forFeature([CompaniesEffects])
  ],
  providers: [
    CompaniesService,
    CompanyService,
    PbxService
  ]
})
export class DomainCompaniesModule { }
